import { loginOutApi } from '@/api/login'
import { usePermissionStoreWithOut } from '@/store/modules/permission'
import { useTagsViewStoreWithOut } from '@/store/modules/tagsView'
import { useUserStoreWithOut } from '@/store/modules/user'
import router from '@/router'

/**
 * 调登出接口并清空 token、用户信息、动态路由缓存（不触发路由跳转）。
 * 用于无后台菜单权限的账号；调用方负责 next(...) 或 router.replace。
 */
export async function clearAdminSessionAfterAccessDenied(): Promise<void> {
  await loginOutApi().catch(() => {})
  const permissionStore = usePermissionStoreWithOut()
  const tagsViewStore = useTagsViewStoreWithOut()
  const userStore = useUserStoreWithOut()
  permissionStore.clearBootstrapState()
  tagsViewStore.delAllViews()
  userStore.setToken('')
  userStore.setUserInfo(undefined)
  userStore.setRoleRouters([])
}

export async function revokeAdminSessionAndRedirectToLogin(): Promise<void> {
  await clearAdminSessionAfterAccessDenied()
  await router.replace({ path: '/login' })
}
